

















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import {
	DxBox, DxItem
} from 'devextreme-vue/box';
import BaseMixin from '@/components/mixins/base';
import DxCheckBox from 'devextreme-vue/check-box';
import DxButton from 'devextreme-vue/button';
import DxList from 'devextreme-vue/list';
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import DxTabs from 'devextreme-vue/tabs';
import { DxToolbarItem } from 'devextreme-vue/popup';

import { Chip, Panel } from '@/components';

import { apiService, customerService } from '@/container';
import { configuration } from '@/configuration';

import { ISharingTo, TargetType } from './types';
import { sortBy } from 'lodash';
import { custom } from 'devextreme/ui/dialog';

@Component({
	components: {
		Chip,
		DxBox, DxButton,
		DxCheckBox,
		DxItem,
		DxList, DxLoadPanel,
		DxScrollView,
		DxTabs, DxToolbarItem,
		Panel
	}
})
export default class ShareDashboardOrChartPanel extends BaseMixin {

	@Prop({ type: Boolean, default: false }) showPanel!: boolean | null;
	@Prop({ type: String, default: null }) idDashboard!: string | null;
	@Prop({ type: String, default: null }) idChart!: string | null;

	internalShowPanel = false;
	isLoading = false;
	isSaving = false;

	sharedTo: ISharingTo[] = [];
	mutableSharedTo: ISharingTo[] = [];

	availableGroups: IGroupItem[] = [];
	availableUsers: IUserItem[] = [];
	availableCompanies: ICompanyItem[] = [];
	dropDownSelectedItems: IGenericItem[] = [];
	availableCustomers: ICustomerItem[] = []

	filterByGroups = true;
	filterByUsers = true;

	controller = 'dashboards';
	id = this.idDashboard;

	tabs = [{
		id: 0,
		text: this.$t('share.all')
	}, {
		id: 1,
		text: this.$t('share.allCompany')
	}, {
		id: 2,
		text: this.$t('share.selected')
	}];

	selectedTabIndex = 0;

	get isSharingDashboard() {
		return _.isString(this.idDashboard) && this.idDashboard.trim() !== '';
	}
	get isSharingChart() {
		return _.isString(this.idChart) && this.idChart.trim() !== '';
	}

	get sharedToByTargedId(): Record<string, ISharingTo> {
		const r: Record<string, ISharingTo> = {};
		this.sharedTo.forEach(s => {
			r[s.idTarget] = s;
		});
		return r;
	}
	get mutableSharedToTargetIds(): Record<string, boolean> {
		const r: Record<string, boolean> = {};
		this.mutableSharedTo.forEach(s => {
			r[s.idTarget] = true;
		});
		return r;
	}

	get showSearchList() {
		//	return this.selectedTabIndex === 2 || (this.selectedTabIndex === 1 && this.availableCompanies.length > 0);
		return true;
	}
	get searchItems(): IGenericItem[] {
		const r: IGenericItem[] = [];
		if (this.selectedTabIndex === 1) { // Companies
			Array.prototype.push.apply(r, sortBy(this.availableCompanies.filter(c => !this.mutableSharedToTargetIds[c.Id]).map(c => ({
				id: c.Id,
				name: c.BusinessName,
				type: TargetType.Company
			})), c => c.name));
		}
		else if (this.selectedTabIndex === 0) { // Customers
			Array.prototype.push.apply(r, sortBy(this.availableCustomers.filter(c => !this.mutableSharedToTargetIds[c.Id]).map(c => ({
				id: c.Id,
				name: c.BusinessName,
				type: TargetType.Customer
			})), c => c.name));
		}
		else {
			if (this.filterByGroups)
				Array.prototype.push.apply(r, sortBy(this.availableGroups.filter(g => !this.mutableSharedToTargetIds[g.Id]).map(g => ({
					id: g.Id,
					name: g.GroupName,
					type: TargetType.Group
				})), g => g.name));
			if (this.filterByUsers)
				Array.prototype.push.apply(r, sortBy(this.availableUsers.filter(u => !this.mutableSharedToTargetIds[u.Id]).map(u => ({
					id: u.Id,
					name: u.FullName,
					type: TargetType.User
				})), u => u.name));
		}
		return r;
	}

	get panelProps() {
		const props: any = {
			title: this.$t('share.chart.title')
		};
		if (this.isSharingDashboard) {
			props['dx-position-props'] = { at: 'left', my: 'left' };
			props.title = this.$t('share.dashboard.title');
		}
		return props;
	}

	get shareButtonProps() {
		return {
			location: 'after',
			options: {
				icon: 'far fa-share-alt',
				onClick: this.onShareClick,
				stylingMode: 'outlined',
				text: this.$t('share.action')
			},
			toolbar: 'bottom',
			widget: 'dxButton'
		};
	}

	get undoButtonProps() {
		return {
			location: 'after',
			options: {
				class: 'mr-2',
				icon: 'far fa-undo',
				onClick: this.onUndoClick,
				stylingMode: 'outlined',
				text: this.$t('share.undo'),
			},
			toolbar: 'bottom',
			widget: 'dxButton'
		};
	}

	get closeButtonProps() {
		return {
			location: 'after',
			options: {
				class: 'mr-2',
				icon: 'far fa-times',
				onClick: this.onCloseClick,
				stylingMode: 'outlined',
				text: this.$t('app.close'),
			},
			toolbar: 'bottom',
			widget: 'dxButton'
		};
	}

	get chipsList() {
		if (this.selectedTabIndex === 0)
			return this.mutableSharedTo.filter(x => x.targetType === 'Customer');

		if (this.selectedTabIndex === 1)
			return this.mutableSharedTo.filter(x => x.targetType === 'Company');

		if (this.selectedTabIndex === 2)
			return this.mutableSharedTo.filter(x => x.targetType === 'Group' || x.targetType === 'User');

		return [];
	}

	async loadData() {
		this.isLoading = true;
		if (this.isSharingChart) {
			this.controller = 'charts';
			this.id = this.idChart;
		}
		const result = await apiService.get<ISharingTo[]>(this.controller, `${this.id}/sharedTo`);
		this.sharedTo = result;
		this.availableGroups = await apiService.post<IGroupItem[]>('group', 'visibleGroups', { idCustomer: customerService.getCustomer() }, {
			axiosConfig: {
				baseURL: configuration.authBackendBaseUrl
			}
		});
		this.availableUsers = await apiService.post<IUserItem[]>('user', 'availableUsers', { idCustomer: customerService.getCustomer() }, {
			axiosConfig: {
				baseURL: configuration.authBackendBaseUrl
			}
		});
		this.availableUsers = this.availableUsers.filter(u => !(this.availableUsers[u.Id] = u.Id in this.availableUsers));
		this.availableCompanies = await apiService.post<ICompanyItem[]>('company', 'visibleCompanies', { idCustomer: customerService.getCustomer() }, {
			axiosConfig: {
				baseURL: configuration.authBackendBaseUrl
			}
		});
		this.availableCustomers = await apiService.post<ICustomerItem[]>('customer', 'userCustomers', { App: 'Dashboard' }, {
			axiosConfig: {
				baseURL: configuration.authBackendBaseUrl
			}
		});
		this.mutableSharedTo = _.cloneDeep(result);
		this.selectedTabIndex = this.getExpectedTabIndex(result);
		if (this.selectedTabIndex === 1)
			this.dropDownSelectedItems = result.map(r => ({
				id: r.idTarget,
				name: r.targetName,
				type: r.targetType
			}));
		this.isLoading = false;
	}

	getExpectedTabIndex(sharedTo: ISharingTo[]) {
		let expectedTabIndex = 0;
		if (sharedTo.length === 0)
			expectedTabIndex = 0;
		else if (sharedTo.some(v => v.targetType === TargetType.Customer))
			expectedTabIndex = 0;
		else if (sharedTo.some(v => v.targetType === TargetType.Company))
			expectedTabIndex = 1;
		else if (sharedTo.every(v => v.targetType === TargetType.Group || v.targetType === TargetType.User))
			expectedTabIndex = 2;
		return expectedTabIndex;
	}

	getChipProps(item: ISharingTo) {
		let infoText = 'G';
		// let infoText = this.$t('share.targetType.G');
		let infoClasses: Record<string, boolean> = {
			'bg-light-blue': true
		};
		if (item.targetType === TargetType.User) {
			infoText = 'U';
			// infoText = this.$t('share.targetType.U');
			infoClasses['bg-light-blue'] = false;
			infoClasses['bg-yellow'] = true;
		}
		else if (item.targetType === TargetType.Company) {
			infoText = 'C';
			// infoText = this.$t('share.targetType.C');
			infoClasses['bg-light-blue'] = false;
			infoClasses['bg-orange'] = true;
		}
		return {
			'close-button': true,
			context: item,
			infoText,
			infoClasses,
			text: item.targetName
		};
	}

	async onShareClick() {
		// if the dashboard was prevously shared meas that we are going to update the list of shared target
		const previousSharing = _.cloneDeep(this.sharedTo);
		const newSharing = _.cloneDeep(this.mutableSharedTo);
		try {
			const hasMacroGroups = await apiService.post('dashboards', 'hasMacroGroups', this.mutableSharedTo);
			if (hasMacroGroups)
				this.confirmDialog(this.$t('dashboard.deleteMacrogroups.warning'), async () => {
					await this.performShareAction();
				});
			else
				await this.performShareAction();
		} finally {
			this.isSaving = false;
		}
	}

	async performShareAction() {
		await apiService.post(this.controller, `${this.id}/share`, this.mutableSharedTo);
		const newSharedTo = this.mutableSharedTo;
		// if we don't close the panel remember to update the sharedTo to and mutableSharedTo objects
		// with the new ids of the sharedTo computed from the backends
		this.sharedTo = newSharedTo;
		this.mutableSharedTo = _.cloneDeep(newSharedTo);

		// if we need ot close the panel
		this.internalShowPanel = false;
	}

	onUndoClick() {
		this.mutableSharedTo = _.cloneDeep(this.sharedTo);
		this.selectedTabIndex = this.getExpectedTabIndex(this.sharedTo);
	}
	onCloseClick() {
		this.internalShowPanel = false;
	}
	onListItemClick({ itemData }: { itemData: IGenericItem }) {
		const s = this.sharedToByTargedId[itemData.id];
		let id = '';
		if (!_.isNil(s)) // in this way we preserve the current sharing of the target
			id = s.id;
		this.mutableSharedTo.push({
			id,
			idTarget: itemData.id,
			targetName: itemData.name,
			targetType: itemData.type
		});
	}
	onChipClose(context: ISharingTo) {
		const index = this.mutableSharedTo.findIndex(s => s.idTarget === context.idTarget);
		if (index > -1)
			this.mutableSharedTo.splice(index, 1);
	}

	onTabItemClick({ itemData: { id: newValue } }: { itemData: { id: number, text: string } }) {
		// if (newValue === 1 && this.availableCompanies.length === 1) {
		// 	const c = this.availableCompanies[0];
		// 	const s = this.sharedToByTargedId[c.Id];
		// 	let id = '';
		// 	if (!_.isNil(s)) // in this way we preserve the current sharing of the target
		// 		id = s.id;
		// 	this.mutableSharedTo = [{
		// 		id,
		// 		idTarget: c.Id,
		// 		targetName: c.BusinessName,
		// 		targetType: TargetType.Company
		// 	}];
		// }
		// if (newValue === 0) {
		// 	const s = customerService.getCustomer();
		// 	const customerName = customerService.getCustomerName();
		// 	let id = '';


		// 	if (s !== null) {
		// 		this.mutableSharedTo = [{
		// 			id,
		// 			idTarget: s,
		// 			targetName: customerName,
		// 			targetType: TargetType.Customer
		// 		}];
		// 	}
		// }
	}

	@Watch('showPanel', { immediate: true })
	async onShowPopupChange(newValue: boolean) {
		this.internalShowPanel = newValue;
		if (newValue) {
			await this.loadData();
		}
	}

	@Watch('internalShowPanel')
	onInternalShowPopupChange(newValue: boolean) {
		this.$emit('update:show-panel', newValue);
	}
}

interface IUserItem {
	Id: string;
	FullName: string;
}

interface IGroupItem {
	Id: string;
	GroupName: string;
}

interface ICompanyItem {
	Id: string;
	BusinessName: string;
}

interface IGenericItem {
	id: string;
	name: string;
	type: TargetType;
}
interface ICustomerItem {
	Id: string;
	BusinessName: string;
}

